var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg003(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 87,
    viewBox: "0 0 86 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 43.5,
    r: 43,
    fill: "#E7FFD8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_218_2388)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.1152 40.2693C53.9944 34.5825 48.9999 30.3134 43 30.3134C38.2363 30.3134 34.099 33.0166 32.0386 36.9726C27.0771 37.5001 23.22 41.7033 23.22 46.7967C23.22 52.2527 27.654 56.6867 33.11 56.6867H54.5383C59.0877 56.6867 62.78 52.9944 62.78 48.445C62.78 44.0934 59.4009 40.566 55.1152 40.2693ZM54.5383 53.39H33.11C29.4672 53.39 26.5166 50.4395 26.5166 46.7967C26.5166 43.4176 29.0386 40.599 32.3847 40.2528L34.1484 40.0715L34.9726 38.5056C36.5385 35.4891 39.6044 33.61 43 33.61C47.3186 33.61 51.0438 36.6759 51.8845 40.9121L52.379 43.3846L54.9009 43.566C57.4723 43.7308 59.4833 45.8901 59.4833 48.445C59.4833 51.1648 57.2581 53.39 54.5383 53.39ZM39.7033 47.0934L36.2583 43.6484L33.9341 45.9725L39.7033 51.7417L49.6098 41.8352L47.2856 39.5111L39.7033 47.0934Z",
    fill: "#46A46C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_218_2388"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39.56,
    height: 39.56,
    fill: "white",
    transform: "translate(23.22 23.72)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg003);
export default __webpack_public_path__ + "static/media/003.a1c33ac486ae6a9af0c608a7e7ef1b01.svg";
export { ForwardRef as ReactComponent };